import { render } from "./GuestHero.vue?vue&type=template&id=716c9118"
import script from "./GuestHero.vue?vue&type=script&lang=js"
export * from "./GuestHero.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__